module.exports = __webpack_public_path__ + "img/u7110.95e956d0.svg";